// src/pages/Dashboard/layout/DashboardLayout.jsx
import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import Footer from './Footer';
import { Outlet } from 'react-router-dom';
import '../../../Stylesheets/Dashboard/DashboardLayout.css';
import AuthBootstrap from './AuthBootstrap';

const DashboardLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const closeSidebar = () => setSidebarOpen(false);

  return (
    <div className="dashboard-layout">
      <Sidebar isOpen={sidebarOpen} closeSidebar={closeSidebar} />

      {/* Backdrop for mobile */}
      {sidebarOpen && <div className="sidebar-backdrop" onClick={closeSidebar}></div>}

      <div className="dashboard-main">
        <AuthBootstrap />
        <Topbar onToggleSidebar={toggleSidebar} />
        <div className="dashboard-content">
          <Outlet />
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
